/* Forever Beside Me - "your 10% off is saved" for visitors from the packaging sticker (version B).
 * Loaded by sections/fbm-topbar.liquid. The B sticker's QR goes /again -> /discount/LOVEIT10 -> the product page,
 * so Shopify keeps the code on the visit (discount_code cookie) and on the cart until checkout. While it is there:
 *  - the top announcement bar says the 10% applies at checkout, on every page;
 *  - a card explains it on every scan of the sticker (closed with "Got it", x, Esc or by adding to cart, it stays
 *    closed on later pages, reloads, back/forward and tab restores until the next scan), and hides while the cart
 *    drawer, the menu or a dialog is open;
 *  - the Klaviyo welcome popup (fbm-popup-timing.js) and its "Get 10% off" teaser stay away.
 * The cart is checked again after add-to-cart and on back/forward, so a replaced, removed or unusable code (or a
 * finished checkout) stops the promise.
 * The A sticker carries no code, so A visitors see none of this.
 * Debug: add ?fbm_offer_debug=1 to the URL. */
(function () {
  'use strict';

  var CODE = 'LOVEIT10';
  var SEEN_KEY = 'fbm_sticker_offer_seen';
  // The sticker picture (Shopify Files); it only loads when the card shows.
  var ICON = 'https://cdn.shopify.com/s/files/1/0782/7410/1295/files/fbm-sticker-b.webp?v=1792972629';
  var CART_URL = ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'cart.js';
  var debug = /[?&]fbm_offer_debug=1/.test(location.search);
  function log() { if (debug) console.log.apply(console, ['[fbm-offer]'].concat([].slice.call(arguments))); }
  if (window.Shopify && Shopify.designMode) return;
  // Every scan shows the card again (owner 11/2): the B sticker's QR lands with utm_campaign=lid_sticker_b, so a new
  // visit to such a page forgets an earlier close on this device. The visit marks its own history entry: a reload,
  // back/forward, or Safari restoring a tab it dropped (while she was in Photos picking a picture) comes back to the
  // same entry and keeps the card closed, while a later scan is a new entry, even in the same tab (review 11/2).
  // Without LOVEIT10 on the visit nothing shows anyway (see check()).
  function newVisit() {
    try {
      var nav = performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
      if (nav && nav.type) return nav.type === 'navigate';
      if (performance.navigation) return performance.navigation.type === 0;
    } catch (e) { /* old browser */ }
    return true;
  }
  // Shopify's Shop sign-in check sends the second page of a visit to shop.app and back; it comes back as a new page
  // with _su_rec in the address (iPhone Safari, live 11/2: a reload after "Got it" showed the card again). A scan
  // lands without a variant in the address, while an open product page has one (pawlight-pdp.js adds it as it starts),
  // so a bounce back to an address with a variant is a page that was already open, not a new scan. The address the
  // page was loaded with is read, not the current one: pawlight-pdp.js runs before this script and has added its own.
  function bounceOfOpenPage() {
    var u = location.href;
    try {
      var nav = performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
      if (nav && nav.name) u = nav.name;
    } catch (e) { /* old browser */ }
    var q = u.split('#')[0].split('?')[1] || '';
    return /(?:^|&)_su_rec(?:_id)?=/.test(q) && /(?:^|&)variant=/.test(q);
  }
  if (/[?&]utm_campaign=lid_sticker_b(?:&|$)/.test(location.search) && newVisit() && !bounceOfOpenPage()) {
    var st = null;
    try { st = history.state; } catch (e) { /* no history access */ }
    if (!(st && st.fbmStickerScan)) {
      try { localStorage.removeItem(SEEN_KEY); } catch (e) { /* storage blocked */ }
      // keep whatever else is in the entry's state (pawlight-pdp.js passes it along on its own replaceState); only a
      // plain object is merged, any other kind of state is left alone
      if (st === null || Object.prototype.toString.call(st) === '[object Object]') {
        try {
          var mark = {};
          for (var k in st) if (Object.prototype.hasOwnProperty.call(st, k)) mark[k] = st[k];
          mark.fbmStickerScan = 1;
          history.replaceState(mark, '');
        } catch (e) { /* history blocked */ }
      }
      log('sticker scan: the card shows again');
    }
  }

  var CSS =
    '.fbm-topbar--offer .fbm-topbar__row,.fbm-topbar--offer .fbm-topbar__rotator{display:none!important}' +
    '.fbm-topbar__offer{display:flex;align-items:center;justify-content:center;padding:0 12px;white-space:nowrap;font-size:min(1em,3.4vw)}' +
    '.fbm-topbar__offer-long{display:none}' +
    '@media screen and (min-width:750px){.fbm-topbar__offer-long{display:inline}.fbm-topbar__offer-short{display:none}}' +
    '[class*="kl-teaser-"]{display:none!important}' +
    '.fbm-offer{position:fixed;left:12px;right:12px;bottom:calc(16px + env(safe-area-inset-bottom,0px));z-index:999;' +
      'box-sizing:border-box;max-width:420px;margin:0 auto;background:#fff;color:#34313A;border-top:5px solid #CCB063;' +
      'border-radius:18px;box-shadow:0 10px 34px rgba(40,25,20,.28);padding:18px 18px 16px;font-family:inherit;' +
      'transition:bottom .25s ease;animation:fbm-offer-in .35s ease both}' +
    '@media (max-width:989px){body:has(.plp-sticky.is-visible,.fbm-pf-sticky.is-visible) .fbm-offer{bottom:84px}}' +
    '@media screen and (min-width:750px){.fbm-offer{left:auto;right:24px;bottom:24px;width:380px}}' +
    // Stay out of the way of whatever they open (the same things fbm-popup-timing.js waits for). Two rules, so
    // browsers without :has() still keep the first one.
    'html.fbm-save-open .fbm-offer,html.plp-viewer-open .fbm-offer{display:none}' +
    'body:has(cart-drawer.active,cart-drawer.is-open,cart-drawer[open],dialog[open],details[open]>.menu-drawer,' +
      '.menu-drawer-container[open],.fbm-proof-dlg:not([hidden])) .fbm-offer{display:none}' +
    '.fbm-offer__row{display:flex;gap:14px;align-items:center;padding-right:18px}' +
    '.fbm-offer__img{width:64px;height:64px;flex:none}' +
    '.fbm-offer__title{margin:0 0 3px;font-family:Newsreader,Georgia,serif;font-size:21px;font-weight:600;line-height:1.15;color:#34313A}' +
    '.fbm-offer__text{margin:0;font-size:14.5px;line-height:1.4}' +
    '.fbm-offer__fine{margin:10px 0 0;font-size:13px;line-height:1.4;color:#6f6975}' +
    '.fbm-offer__fine strong{font-weight:700;color:#34313A}' +
    '.fbm-offer__btn{display:block;width:100%;margin-top:12px;padding:13px 0;border:0;border-radius:999px;background:#B2585F;' +
      'color:#fff;font-family:inherit;font-size:15px;font-weight:700;line-height:1;cursor:pointer}' +
    '.fbm-offer__x{position:absolute;top:6px;right:6px;width:40px;height:40px;border:0;background:none;color:#8a8490;' +
      'font-size:24px;line-height:1;cursor:pointer}' +
    // Small phones (360 px is the common Android width): a more compact card covers less of the product.
    '@media (max-width:360px){.fbm-offer{padding:14px}.fbm-offer__img{width:48px;height:48px}.fbm-offer__title{font-size:19px}}' +
    '@keyframes fbm-offer-in{from{opacity:0;transform:translateY(16px)}to{opacity:1;transform:none}}' +
    '@media (prefers-reduced-motion:reduce){.fbm-offer{animation:none}}';

  function whenReady(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }
  function seen() { try { return localStorage.getItem(SEEN_KEY) === CODE; } catch (e) { return false; } }
  function markSeen() { try { localStorage.setItem(SEEN_KEY, CODE); } catch (e) { /* storage blocked */ } }
  function cookieHasCode() { return new RegExp('(?:^|;\\s*)discount_code=' + CODE + '(?:;|$)', 'i').test(document.cookie); }
  function hasCart() { return /(?:^|;\s*)cart=/.test(document.cookie); }
  function hasDiscountCookie() { return /(?:^|;\s*)discount_code=/.test(document.cookie); }

  function showBar() {
    var bars = document.querySelectorAll('.fbm-topbar');
    for (var i = 0; i < bars.length; i++) {
      if (bars[i].querySelector('.fbm-topbar__offer')) continue;
      bars[i].classList.add('fbm-topbar--offer');
      bars[i].insertAdjacentHTML('beforeend', '<span class="fbm-topbar__offer" role="status">' +
        '<span class="fbm-topbar__offer-long">&#127873; Your 10% off is saved &mdash; it applies automatically at checkout</span>' +
        '<span class="fbm-topbar__offer-short">&#127873; 10% off applies at checkout</span></span>');
    }
  }
  function hideBar() {
    var bars = document.querySelectorAll('.fbm-topbar--offer');
    for (var i = 0; i < bars.length; i++) {
      bars[i].classList.remove('fbm-topbar--offer');
      var o = bars[i].querySelector('.fbm-topbar__offer');
      if (o) o.parentNode.removeChild(o);
    }
  }

  var card, prevFocus;
  function removeCard() {
    if (!card) return;
    // If they were on one of its buttons, give focus back to where it was before the card appeared.
    var hadFocus = card.contains(document.activeElement);
    if (card.parentNode) card.parentNode.removeChild(card);
    card = null;
    document.removeEventListener('keydown', onKey, true);
    if (hadFocus && prevFocus && prevFocus.focus && document.contains(prevFocus)) prevFocus.focus();
  }
  function closeCard() { markSeen(); removeCard(); log('card closed'); }
  // Escape closes the card only while it can be seen: with the style viewer, the cart drawer or a dialog open, the
  // card is hidden by the CSS above and that Escape belongs to them. Listened to in the capture phase, so the check
  // runs before such an overlay closes itself on the same key (which would show the card again first).
  function onKey(e) { if (e.key === 'Escape' && card && getComputedStyle(card).display !== 'none') closeCard(); }
  function showCard() {
    if (card || seen() || /^\/cart(\/|$)/.test(location.pathname)) return;
    prevFocus = document.activeElement;
    card = document.createElement('div');
    card.className = 'fbm-offer';
    card.setAttribute('role', 'region');
    card.setAttribute('aria-labelledby', 'fbm-offer-title');
    card.innerHTML =
      '<button type="button" class="fbm-offer__x" aria-label="Close">&times;</button>' +
      '<div class="fbm-offer__row">' +
        '<img class="fbm-offer__img" src="' + ICON + '" alt="" width="64" height="64">' +
        '<div><p class="fbm-offer__title" id="fbm-offer-title">Your 10% off is&nbsp;saved</p>' +
        '<p class="fbm-offer__text">It applies automatically at checkout &mdash; no code needed.</p></div></div>' +
      // The code is only a backup, for when they order later from another phone or computer.
      '<p class="fbm-offer__fine">Using another device? Enter <strong>' + CODE + '</strong> at checkout.</p>' +
      '<button type="button" class="fbm-offer__btn">Got it</button>';
    card.querySelector('.fbm-offer__x').addEventListener('click', closeCard);
    card.querySelector('.fbm-offer__btn').addEventListener('click', closeCard);
    document.addEventListener('keydown', onKey, true);
    document.body.appendChild(card);
    log('card shown');
  }

  // fbm-popup-timing.js (loaded earlier) exposes its state; a stop reason there keeps the welcome popup closed.
  function stopWelcomePopup() {
    var p = window.fbmPopup && window.fbmPopup.state;
    if (p && !p.stopped && !p.opened) { p.stopped = 'sticker offer'; log('welcome popup stopped'); }
  }

  var active = false;
  var styled = false;
  function activate(source) {
    stopWelcomePopup();
    if (active) return;
    active = true;
    log('on via', source);
    if (!styled) {
      styled = true;
      var style = document.createElement('style');
      style.textContent = CSS;
      document.head.appendChild(style);
    }
    whenReady(function () { if (active) { showBar(); showCard(); } });
  }
  function deactivate(reason) {
    if (!active) return;
    active = false;
    log('off:', reason);
    hideBar();
    removeCard();
  }

  // The cart is the source of truth: LOVEIT10 must still be on it, and usable once there is something to buy.
  var checkId = 0;
  function check(why) {
    if (!window.fetch) return;
    // No cart and no discount cookie means no code anywhere: fresh visitors skip the request, and a page restored
    // after a finished checkout (Shopify drops the cart cookie) stops promising.
    if (!hasCart() && !hasDiscountCookie()) { deactivate('no cart'); return; }
    var id = ++checkId;
    fetch(CART_URL, { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.json() : null; }).then(function (cart) {
      if (!cart || id !== checkId) return;
      var list = cart.discount_codes || [], hit = null;
      for (var i = 0; i < list.length; i++) if (String(list[i].code || '').toUpperCase() === CODE) hit = list[i];
      // Not on the cart (another code took its place, or the codes were removed): stop. The one exception is the
      // moment right after the discount link, while the cart is still empty and the cookie still says LOVEIT10:
      // then the cookie counts.
      if (!hit) {
        if (list.length || cart.item_count > 0 || !cookieHasCode()) deactivate('code not on the cart');
        else activate('cookie, empty cart');
        return;
      }
      // An empty cart always reports applicable:false; with items in it, false means Shopify won't take the code
      // (e.g. its 300-use cap is reached), so stop promising the discount.
      if (cart.item_count > 0 && hit.applicable === false) deactivate('code not applicable');
      else activate(why);
    }).catch(function () {});
  }

  // Before a cart exists the discount link's cookie is all there is; once there is a cart, wait for its answer
  // (so a removed code doesn't flash the bar for a moment).
  if (cookieHasCode() && !hasCart()) activate('cookie');
  check('cart');
  // fbm-popup-timing.js fires fbm:cart-add after every successful add-to-cart.
  document.addEventListener('fbm:cart-add', function () {
    if (active) closeCard();
    setTimeout(function () { check('cart change'); }, 400);
  });
  // A page restored from the back/forward cache comes back exactly as it was left.
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    if (seen()) removeCard();
    check('back/forward');
  });
})();